import * as types from '../../../../constants/ActionNameConstants';

const initialState = {
  loading: false,
  error: null,
};

const UpdateSpeakerReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_SPEAKERS_REQUEST:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.UPDATE_SPEAKERS_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.UPDATE_SPEAKERS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default UpdateSpeakerReducer;
